import {
  HANDLE_WALLET,
  ADD_NEW_WALLET,
  DISCONNECT_WALLET,
  OPEN_BUY_GAINS_MODEL,
  OPEN_GAINS_CONFIRMATION_MODEL,
  SET_WEB3_PROVIDER,
  SET_CHAIN_AND_NETWOR_ID,
  UPDATE_WALLET_BALANCE,
  SET_USER_WALLETS,
  SET_CURRENT_WALLET,
  SET_WEB3,
  SET_CONNECTOR_NAME,
  WALLET_NOT_FOUND,
  UPDATE_GAS_BALANCE
} from "../action";

const WalletReducer = (state: any, action: any) => {
  switch (action.type) {
    case HANDLE_WALLET: {
      localStorage.setItem("isconnected", "true");
      return {
        ...state,
        address: action.payload.address,
        walletId: action.payload.id,
        amount: action.payload.amount,
        isconnected: true,
        chainName: action.payload.chainName,
        currency: action.payload.currency,
        gainsBalance: action.payload.gainsBalance,
        networkId: action.payload.networkId,
      };
    }
    case DISCONNECT_WALLET: {
      localStorage.setItem("isconnected", "false");
      return {
        ...state,
        address: null,
        walletId: null,
        amount: 0,
        isconnected: false,
        chainId: null,
        currency: null,
        chainName: null,
        gainsBalance:0,
        web3: null,
        provider: null,
        connectorByName: null,
        balancePollId: null,
        networkId: null,
      };
    }
    case WALLET_NOT_FOUND: {
      return {
        ...state,
        address: null,
        amount: null,
        gainsBalance: null,
        isconnected: false,
      }
    }
    case ADD_NEW_WALLET: {
      return {
        ...state,
        wallets: [ ...state.wallets, action.payload ],
        isconnected: true,
      }
    }
    case SET_USER_WALLETS: {
      const hasKycWallet = action.payload.find((wallet: any) => wallet.isKycVerified && wallet.isKycVerified === true);
      return {
        ...state,
        wallets: action.payload,
        hasKycWallet: hasKycWallet,
      }
    }
    case SET_CURRENT_WALLET: {
      return {
        ...state,
        address: action.payload.address,
        walletId: action.payload.id,
        amount: action.payload.balance,
        isconnected: true,
      }
    }
    case UPDATE_WALLET_BALANCE: {
      return {
        ...state,
        gainsBalance: action.payload
      }
    }
    case UPDATE_GAS_BALANCE: {
      return {
        ...state,
        amount: action.payload
      }
    }
    case OPEN_BUY_GAINS_MODEL: {
      return {
        ...state,
        openmodal: true,
      };
    }
    case OPEN_GAINS_CONFIRMATION_MODEL: {
      return {
        ...state,
        openmodal: false,
      };
    }
    case SET_WEB3_PROVIDER: {
      return {
        ...state,
        provider: action.payload
      }
    }
    case SET_WEB3: {
      return {
        ...state,
        web3: action.payload
      }
    }
    case SET_CHAIN_AND_NETWOR_ID: {
      return {
        ...state,
        chainId: action.payload.chainId,
        networkId: action.payload.networkId
      }
    }
    case SET_CONNECTOR_NAME: {
      return {
        ...state,
        connectorByName: action.payload
      }
    }
    default: {
      return state;
    }
  }
};

export default WalletReducer;
